<template>
  <Main>
    <div class="ma-12">
      <FixedHeaderTable
          title="PSIs Database"
          :data="psiTypes"
          :headers="headers">
      </FixedHeaderTable>
    </div>
  </Main>
</template>

<script setup>
import Main from "@/Layouts/Main.vue";
import FixedHeaderTable from "../../Shared/FixedHeaderTable.vue";

const props = defineProps({
  psiTypes: {
    type: Array,
    required: true
  }
})

const headers = [
  {title: 'Name', key: 'name'},
  {title: 'Functional unit', key: 'functional_unit'}
]


</script>

<style scoped>
</style>